import React, { useEffect, useState } from 'react';
import { FaRegFileAlt, FaThLarge } from 'react-icons/fa';
import { Modal, Button, Table } from 'react-bootstrap';
import axios from 'axios';
import { useDropzone } from 'react-dropzone';
import { baseurl, imageUrl } from '../Baseurl';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { downloadFile } from '../utils/downloadFile';


export default function ProjectDocs({ projectId }) {
  const [show, setShow] = useState(false);
  const [files, setFiles] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    fetchExistingFiles();
    setShow(true);
  };

  const onDrop = (acceptedFiles) => {
    setFiles((prev) => [...prev, ...acceptedFiles]);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const fetchExistingFiles = async () => {
    try {
      const res = await axios.get(`${baseurl}getProjectFiles/${projectId}`);
      setExistingFiles(res.data || []);
    } catch (error) {
      console.error('Error fetching files:', error);
    }
  };
const adminID = localStorage.getItem('adminID');

  const handleFileUpload = async () => {
    const formData = new FormData();
    formData.append('project_id', projectId);
    formData.append('adminID', adminID);
    files.forEach(file => formData.append('files', file)); // Match Multer field

    try {
      await axios.post(`${baseurl}uploadProjectFiles`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      toast.success('Files uploaded successfully!');
      setFiles([]);
      fetchExistingFiles();
    } catch (err) {
      console.error('Upload error:', err);
      toast.error('File upload failed.');
    }
  };

  const handleDelete = async (fileId) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this file?');
    if (!confirmDelete) return;

    try {
      await axios.delete(`${baseurl}deleteProjectFile/${fileId}`);
      toast.success('File deleted successfully!');
      fetchExistingFiles();
    } catch (error) {
      console.error('Delete error:', error);
      toast.error('Failed to delete file.');
    }
  };

  return (
    <>
      <div className="btn btn-light btn-sm d-flex align-items-center " onClick={handleShow}>
        <FaRegFileAlt /> Manage Documents
      </div>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Manage Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Dropzone */}
          <div
            {...getRootProps()}
            className="border p-4 text-center mb-3"
            style={{ borderStyle: 'dashed', cursor: 'pointer', background: isDragActive ? '#f8f9fa' : 'white' }}
          >
            <input {...getInputProps()} />
            {isDragActive ? <p>Drop the files here ...</p> : <p>Drag & drop files here, or click to select</p>}
          </div>

          {/* Selected Files */}
          {files.length > 0 && (
            <div className="mb-3">
              <strong>Files to Upload:</strong>
              <ul className="mb-0">
                {files.map((file, idx) => (
                  <li key={idx}>{file.name}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Existing Files Table */}
          <h6>Existing Files</h6>
          <Table striped bordered hover className='custom-table'>
            <thead>
              <tr>
                <th>#</th>
                <th>Filename</th>
                <th>Uploaded At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {existingFiles.map((file, idx) => (
                <tr key={file.id}>
                  <td>{idx + 1}</td>
                  <td>{file.file_name}</td>
                  <td>{new Date(file.uploaded_at).toLocaleString()}</td>
                  <td className="d-flex gap-2">
                   <Button
  variant="primary"
  size="sm"
  onClick={() =>
    downloadFile(`${imageUrl}${file.file_path}`, file.file_name)
  }
>
  Download
</Button>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDelete(file.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
              {existingFiles.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center">No files uploaded yet.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary" onClick={handleFileUpload} disabled={files.length === 0}>
            Upload Files
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Toast Notifications */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar closeOnClick />
    </>
  );
}
